export default "__VITE_ASSET__CkG$Opl4__"